export function debounce<T extends (...args: never[]) => unknown>(
  fn: T,
  timer: number
) {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  function debouncer(...args: Parameters<T>) {
    if (timeout !== null) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      fn(...args);
    }, timer);
  }

  return debouncer;
}
